import React from 'react';
import './App.css';
import Profile from './components/Profile';


function App() {
  return (
    <div className="App">
      <Profile />
    </div>
  );
}

export default App;


// npm run build
// firebase login --reauth
//firebase deploy --only hosting:akash-karwande
